module.exports = __webpack_public_path__ + "img/logo-xs.9ec75de5.png";